import { render } from "./Dashboard.vue?vue&type=template&id=7f0ae67c"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render

export default script